import { BreadcrumbItem } from "common/components/breadcrumb/Breadcrumb";
import { TallLayout } from "common/components/layouts/TallLayout";
import { H1 } from "common/components/Typography";
import React from "react";
import { ContentBreadcrumbFragment_context } from "__generated__/types";
import { ContentNotWide } from "./ContentNotWide";

interface Props {
  title: string;
  breadcrumbItems?: BreadcrumbItem[];
  context?: ContentBreadcrumbFragment_context[];
}

export const AdministrationLayout: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  children,
  context,
}) => {
  return (
    <TallLayout context={context}>
      <H1>{title}</H1>
      <ContentNotWide>{children}</ContentNotWide>
    </TallLayout>
  );
};
